var rules = function rules(vs) {
  return function (t) {
    var _ref;

    return (_ref = []).concat.apply(_ref, vs.map(function (i) {
      return i(t);
    }));
  };
};
var nestedRule = function nestedRule(k, v) {
  return function (t) {
    return typeof t === "object" && t != null ? v(t[k]).map(function (_ref2) {
      var error = _ref2.error,
          field = _ref2.field;
      return {
        error: error,
        field: k + "." + field
      };
    }) : [];
  };
};
var conditional = function conditional(c, v) {
  return function (t) {
    return c(t) ? v(t) : [];
  };
};
var POSTAL_CODE = /^\d{3}\s?\d{2}$/;
var EMAIL = /^[!#$%&'*+/=?^_`{|}~\-a-z0-9]+(?:\.[!#$%&'*+/=?^_`{|}~\-a-z0-9]+)*@(?:[a-z0-9]+(?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]([a-z0-9-]*[a-z0-9])*$/i;
var PHONE = /^(?=.*\d{2,})[-\s+()0-9]+$/;
var isRequired = function isRequired(f) {
  return function (t) {
    return typeof t === "object" && t && (t[f] || t[f] === 0) ? [] : [{
      error: "REQUIRED",
      field: f
    }];
  };
};
var lengthGt = function lengthGt(f, l) {
  return function (t) {
    return typeof t[f] === "string" && t[f].length > l ? [] : [{
      error: "LENGTH_GT",
      field: f,
      lengthGt: l
    }];
  };
};
var lengthLt = function lengthLt(f, l) {
  return function (t) {
    return typeof t[f] === "string" && t[f].length < l ? [] : [{
      error: "LENGTH_LT",
      field: f,
      lengthLt: l
    }];
  };
};
var isTruthy = function isTruthy(f) {
  return function (t) {
    return t[f] ? [] : [{
      error: "TRUTHY",
      field: f
    }];
  };
};
var match = function match(f1, f2) {
  return function (t) {
    return t[f1] === t[f2] ? [] : [{
      error: "MATCH",
      field: f2,
      match: f2
    }];
  };
};
var isPhone = function isPhone(f) {
  return function (t) {
    return typeof t[f] === "string" && PHONE.test(t[f]) ? [] : [{
      error: "PHONE",
      field: f
    }];
  };
};
var isPostalCode = function isPostalCode(f) {
  return function (t) {
    var value = parseInt(String(t[f]).replace(/\s/g, ""), 10);
    return POSTAL_CODE.test(String(t[f])) && !isNaN(value) && value > 10000 ? [] : [{
      error: "POSTCODE",
      field: f
    }];
  };
};
var isEmail = function isEmail(f) {
  return function (t) {
    return typeof t[f] === "string" && EMAIL.test(t[f]) ? [] : [{
      error: "EMAIL",
      field: f
    }];
  };
};

var numeric = function numeric(x) {
  return !isNaN(x - parseFloat(x));
};

var isNumeric = function isNumeric(f) {
  return function (t) {
    return numeric(t[f]) ? [] : [{
      error: "NUMERIC",
      field: f
    }];
  };
};

export { conditional, isEmail, isNumeric, isPhone, isPostalCode, isRequired, isTruthy, lengthGt, lengthLt, match, nestedRule, rules };
//# sourceMappingURL=validation.js.map
